<div>
 Insert app-specific content here for this type of ShoppingCartItem.
 (You should never see this one for the base-class ShoppingCartItemComponent)
</div>
